<template>
  <div class="page qyfz" :style="bgimg">
    
    <div :class="contentClass">
      <div class="tab-title">
        <img :src="title">
      </div>
      <m-textarea :class="curretTabName">
        <div :class="lngClass" v-html="content" ref="qyfztext"></div>
      </m-textarea>
    </div>
    
    <BottomNav
      :page="page"
      :items="tabs"
      :active="currentTab"
      btnclass="qyfz-nav"
      @changeNav="changeTab"
      wrap
    ></BottomNav>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import BottomNav from "@/components/BottomNav.vue";
import TextArea from "@/components/TextArea.vue";

export default {
  components: {
    BottomNav,
    "m-textarea": TextArea
  },
  data() {
    return {
      page: "qyfz",
      currentTab: 0,
      curretTabName: "qiyuan",
      bgimg: { backgroundImage: `url("img/qyfz/qyfz-bg.jpg")` }
    };
  },
  computed: {
    ...mapState({
      tabs: state => state.tabs.qyfz,
      qyfz: "qyfz"
    }),
    ...mapGetters(["lngClass"]),
    contentClass() {
      return `${this.page}-tabs`;
    },
    content() {
      const tabData = this.qyfz[this.curretTabName];
      if (tabData) {
        return tabData.content;
      }
    },
    title() {
      return this.tabs[this.currentTab].ttimg;
    }
  },
  mounted() {
    this.getContent({
      page: this.page,
      tab: "qiyuan"
    });
  },
  updated() {
    // 每列最大容量，每行16个字，16行，总共288个字
    const reg = !this.lngClass
      ? /(.|\n){1,270}/g
      : /(\W?\w+\W*\w*\W*\s?|\n){1,36}/g;
    const texts = this.$refs.qyfztext.getElementsByTagName("p");
    for (let txt of texts) {
      if (txt.getElementsByTagName("span")[0]) {
        return;
      }
      if (txt.innerText.length > 300) {
        const arr = txt.innerHTML.match(reg);
        const inhtml = arr.join("</span><span>");
        txt.innerHTML = `<span>${inhtml}</span>`;
        txt.className = "hascolumn";
      }
    }
  },
  methods: {
    ...mapActions(["getContent"]),
    changeTab(activeNum) {
      const tabName = this.tabs[activeNum].name;
      this.getContent({
        page: this.page,
        tab: tabName
      });
      this.currentTab = activeNum;
      this.curretTabName = tabName;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.qyfz-nav {
  max-width: 33.3%;
  margin-left: 1.2rem;
  margin-right: 1.2rem;

  @include tab1;
}

.qyfz-tabs {
  position: relative;
  display: flex;
  overflow-x: auto;
  padding-top: 4rem;
  padding-left: 8rem;
  @include hide-scrollbar;

  .tab-title {
    position: relative;
    flex-shrink: 0;
    flex-basis: 6rem;
    width: 6rem;
    margin-right: 4rem;
    @include img-fluid;
  }

  .textarea {
    flex-shrink: 0;
    height: 22.4rem;
  }

  .text-main {
    white-space: nowrap;
    h4,
    p {
      display: inline-block;
      margin: 0;
      text-align: justify;
      vertical-align: top;
      white-space: normal;
    }
    h4 {
      width: 1rem;
      line-height: 1.2;
    }
    p {
      width: 18em;
      margin-left: 1rem;
      margin-right: 2rem;
      font-size: 0.875rem;
    }
    p.hascolumn {
      width: auto;
      white-space: nowrap;

      span {
        display: inline-block;
        width: 18em;
        margin-right: 1.5rem;
        vertical-align: top;
        white-space: normal;
      }
    }

    .lng {
      white-space: normal;
      h3 {
        position: absolute;
        display: inline-block;
        margin: 0;
        font-size: 1rem;
        font-weight: normal;
      }

      p {
        position: relative;
        top: 3rem;
        margin-bottom: 1rem;
      }
    }
  }
}

.qiyuan,
.chuanbo {
  .text-main h4 {
    padding: 1rem 0.5rem 3rem;
    font-size: 0.75rem;
    line-height: 1;
    color: #fff;
    text-align: center;
    background-image: url("~@/assets/img/qiyuan-h4.png");
    background-size: 100%;
    background-repeat: no-repeat;
  }
}

.fazhan {
  img {
    margin-top: 2rem;
    @include scaleimg(0.5);
  }

  .text-main p {
    margin-left: -1.2rem;
  }
}
</style>
